export function testingCards() {
    const cardsWrap = $(".testing-cards");
    const cardsLength = cardsWrap.find('.card').length;

    if (cardsLength < 4) {
        cardsWrap.addClass('one-row');
    } else if (cardsLength < 7) {
        cardsWrap.addClass('two-rows');
    } else {
        cardsWrap.addClass('three-rows');
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/testingCards.js